import { Component, OnInit, Input, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { IRejectionReason } from '../../../../../src/app/static-data/models/rejection-reason.model';
import { saveUploadedFileToStore, loadGetUploadedDocs } from '../../../../app/features/employee-detail/actions/get-uploaded-doc.actions';
import { fromOpenFileSelector } from '../../../features/employee-detail/selectors';
import { IUploadDocsParams } from '../../../features/employee-detail/models/IUploadDocsParams.model';
import { loadDownloadFile } from '../../../static-data/actions';
import { IDownloadFileRequest } from '../../../static-data/models/download-file.model';
import { fromSelectedBusinessSelector } from '../../../features/businesses/selectors';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import { fromStaticDataRejectionReasonSelector } from '../../../static-data/selectors';
import {
  IApproveBankProofRequest,
  IRejectBankProofRequest,
  RejectBankProofReason
} from '../../../../../src/app/features/employee-detail/models/bank-proof.model';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { APP_CONFIG } from '../../../../../src/app/config/app-config.module';
import { AppConfig } from '../../../../../src/app/core/config-models/app-config.model';
import { fromBankProofDocumentsActions } from '../../../features/employee-detail/actions';
import { DxFileUploaderComponent } from 'devextreme-angular'
import { IApproveBankProofDocumentRequest, IRejectBankProofDocumentRequest } from '../../../features/employee-detail/models/bank-proof-documents.model';
import * as fromStaticDataActions from '../../../static-data/actions';
import {
  hasNonBlankEmployeeRejectionMessage,
  hasRejectionReasonSelection
} from 'src/app/shared/utils/document-rejection-form.util';
import { IStaticDataResponse } from '../../../static-data/models/static-data.model';
import { getStaticDataProofOfBankDocumentTypesResponse } from '../../../static-data/selectors/proof-of-bank-document-types.selectors';

@Component({
  selector: 'app-bankproof-validation',
  templateUrl: './bankproof-validation.component.html',
  styleUrls: ['./bankproof-validation.component.css']
})
export class BankProofValidationComponent implements OnInit, OnDestroy {
  @ViewChild('fubauto', { static: false }) fileUploader: DxFileUploaderComponent;

  @Input() currentImageData: any;
  @Input() imagesForPrevious: any;
  @Input() bankAccountId: string;
  @Input() showFicaBtn: boolean = false;
  @Input() showUploadBtn: boolean = false;

  videoFile: any;
  video: boolean;

  imageClicked: boolean;
  getCurrentPicObs$: Observable<any>;
  openPic: boolean;
  extraInfo: string;

  getUploadedFileStatus$: Observable<boolean>;
  displayRejectModal: boolean;
  fileID: string;
  fileType: string;
  fileTypeId: string;
  reason: string;
  privateNotes: string;
  option: IRejectionReason;
  rejectionReason$: Observable<IRejectionReason[]>;
  subscription: Subscription = new Subscription();
  chosen: string;
  businessId: string;
  displayUploadModal: boolean;
  fileNameFICA: string;
  uploadFICAURL: string;
  selectedTabIndex:number = 0;
  tabsWithText:any[];
  headers: any;
  allRejectionReasons: any[];
  selectedRejectReason: any;
  /** Set true after a failed reject submit; drives inline validation messages. */
  rejectionSubmitAttempted = false;
  proofOfBankDocumentTypes$: Observable<IStaticDataResponse[]>;
  proofOfBankDocumentTypes: IStaticDataResponse[] = [];
  selectedDocumentTypeId: string = '';
  selectedDocumentType: IStaticDataResponse | null = null;

  // Replace popup properties
  displayReplaceModal: boolean = false;
  currentFileToReplace: any = null;

  constructor(
    private store: Store,
    private helperService: HelpersService,
    private analytics: AngularFireAnalytics,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.rejectionReason$ = this.store.select(fromStaticDataRejectionReasonSelector.getStaticDataRejectionResponse);
    this.rejectionReason$.subscribe(response=>{
      this.allRejectionReasons = response;
    });
    this.tabsWithText = [
      {id:1, text:'Current'},
      {id:2, text:'Archived'}
    ];

    // Initialize document types
    this.proofOfBankDocumentTypes$ = this.store.select(getStaticDataProofOfBankDocumentTypesResponse);
    this.proofOfBankDocumentTypes$.subscribe((proofOfBankDocumentTypes: IStaticDataResponse[]) => {
      this.proofOfBankDocumentTypes = proofOfBankDocumentTypes || [];
    });
  }

  ngOnInit() {
    this.displayRejectModal = false;
    this.displayUploadModal = false;

    this.subscription.add(
      this.store.select(fromSelectedBusinessSelector.getSelectedBusinesses).subscribe(data => {
        if (data != undefined) {
          this.businessId = data.id;
        }
      })
    );

    var bearerToken = sessionStorage.getItem('token');
    this.headers = { 'Authorization': `Bearer ${bearerToken || ''}` };

    // Load proof of bank document types
    this.loadBankProofTypes();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSelectionChanged(e){
    var index = e.addedItems[0].id - 1;
    this.selectedTabIndex = index;
  }

  openFileInBrowser(val) {
    this.analytics.logEvent('view document in browser');
    const ext = val?.fileName?.match(/\.([a-zA-Z0-9]+)(?:\?|$)/)?.[1];
    const req: IDownloadFileRequest = {
      documentName: val.fileName,
      ...(ext && { imageType: ext })
    };
    this.store.dispatch(loadDownloadFile({ request: req }));
  }

  openFileInBrowser2(extension: string, newBase64Str: string) {
    var win;

    switch (true) {
      case extension === 'jpeg' ||
        extension === 'JPG' ||
        extension === 'png' ||
        extension === 'PNG' ||
        extension === 'txt' ||
        extension === 'JPEG' ||
        extension === 'jpg' ||
        extension === 'TXT' ||
        extension === 'tiff' ||
        extension === 'TIFF':
        win = window.open();

        let data = `data:image/${extension};base64,${newBase64Str}`;

        win.document.write(
          '<iframe src="' +
            data +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
        break;
      case extension === 'rtf':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/rtf;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'xml':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/xml;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'pdf' || extension === 'PDF':
        win = window.open();
        win.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(newBase64Str) + "'></iframe>"
        );
        break;
      case extension === 'mp4' ||
        extension === 'm4v' ||
        extension === '3gp' ||
        extension === 'avi' ||
        extension === 'flv' ||
        extension === 'mkv' ||
        extension === 'mov' ||
        extension === 'mpeg' ||
        extension === 'mpg' ||
        extension === 'mts' ||
        extension === 'vob' ||
        extension === 'webm' ||
        extension === 'wmv':
        this.videoFile = `data:${extension};base64,${newBase64Str}`;
        this.video = true;
        break;
      default:
        break;
    }
  }

  get showRejectionReasonError(): boolean {
    return (
      this.rejectionSubmitAttempted &&
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option)
    );
  }

  get showEmployeeMessageError(): boolean {
    return this.rejectionSubmitAttempted && !hasNonBlankEmployeeRejectionMessage(this.reason);
  }

  saveRejectionReason() {
    this.rejectionSubmitAttempted = true;
    if (
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option) ||
      !hasNonBlankEmployeeRejectionMessage(this.reason)
    ) {
      return;
    }
    this.rejectionSubmitAttempted = false;

    const rejectReason: RejectBankProofReason = {
      adminPrivateNotes: this.privateNotes,
      extraInfo: this.reason,
      uploadedFileRejectReasonId: this.selectedRejectReason.id
    };

    const req: IRejectBankProofDocumentRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      bankAccountId: this.bankAccountId,
      uploadedFileId: this.fileID,
      rejectReason: rejectReason
    };

    this.store.dispatch(
      fromBankProofDocumentsActions.rejectBankProofDocumentRequest({
        request: req
      })
    );
    this.displayRejectModal = false;
  }

  /* #region  decline doc */
  declineDocument(uploadedFileId, uploadedFileTypeDescription, uploadedFileTypeId) {
    this.displayRejectModal = true;
    this.fileID = uploadedFileId;
    this.fileType = uploadedFileTypeDescription;
    this.fileTypeId = uploadedFileTypeId;

    this.privateNotes = '';
    this.reason = '';
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
    this.option = {
      id: '',
      description: '',
      extraInfo: ''
    };
  }
  /* #endregion */

  close() {
    this.imageClicked = false;
    this.video = false;
  }

  imageApproveFunction(uploadedFileId, userIdentityId, uploadedFileTypeDescription, uploadedFileTypeId) {
    const req: IApproveBankProofDocumentRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      uploadedFileId: uploadedFileId,
      bankAccountId: this.bankAccountId
    };

    this.store.dispatch(
      fromBankProofDocumentsActions.approveBankProofDocumentRequest({
        request: req
      })
    );
  }

  onImageStatus(val) {}

  onChangeTab($event) {}

  selected(e) {
    this.selectedRejectReason = this.allRejectionReasons.find(item => item.id === e.value);
    this.reason = this.selectedRejectReason?.extraInfo ?? '';
  }

  uploadDoc() {
    this.displayUploadModal = false;
  }

  delete() {}

  replaceFICADocument(file) {
    this.currentFileToReplace = file;
    this.selectedDocumentTypeId = '';
    this.selectedDocumentType = null;
    this.displayReplaceModal = true;
  }

  ficaDocUploadControl(val, fileUploader) {
    this.helperService.notifySuccess('Uploaded succesfully', 300, 3000);

    this.store.dispatch(
      fromBankProofDocumentsActions.loadCurrentBankProofDocuments({
        customerId: this.helperService.checkCustomerIdState(),
        bankAccountId: this.bankAccountId
      })
    );

    this.fileUploader.instance.reset();

    // Reset document type selection after successful upload
    this.selectedDocumentTypeId = '';
    this.selectedDocumentType = null;
  }

  errorUploadedFICA(fileUploader, error) {
    this.helperService.handleGeneralErrors(false, 'Oops', `${error.error.status} - ${error.error.statusText}`);
    this.fileUploader.instance.reset();
  }

  closeRejectionPop(){
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
  }

  loadBankProofTypes() {
    this.store.dispatch(fromStaticDataActions.fromProofOfBankDocumentTypesAction.loadProofOfBankDocumentTypes());
  }

  onDocumentTypeChanged(e: any) {
    this.selectedDocumentTypeId = e.value;
    this.selectedDocumentType = this.proofOfBankDocumentTypes.find(docType => docType.id === e.value) || null;

    // Automatically prepare the upload URL when document type is selected
    if (this.selectedDocumentTypeId && this.currentFileToReplace) {
      this.prepareReplaceUpload();
    }
  }

  customProofOfBankDocumentTypeHandler(e: any) {
    var selectedProofOfBankDocumentType = this.proofOfBankDocumentTypes.find(p => p.description === e.text);
    if(selectedProofOfBankDocumentType){
        e.customItem = selectedProofOfBankDocumentType[0];
    }
  }

  // Replace popup methods
  openReplacePopup(file: any) {
    this.replaceFICADocument(file);
  }

  closeReplacePopup() {
    this.displayReplaceModal = false;
    this.currentFileToReplace = null;
    this.selectedDocumentTypeId = '';
    this.selectedDocumentType = null;
    this.fileNameFICA = '';
    this.uploadFICAURL = '';
  }

  prepareReplaceUpload() {
    if (!this.currentFileToReplace || !this.selectedDocumentTypeId) {
      return;
    }

    if (this.currentFileToReplace.uploadedFileTypeDescription === 'Proof of bank account' ||
      this.currentFileToReplace.uploadedFileTypeDescription === 'Bank Proof'
    ) {
      let uploadedFileBankProofId = this.currentFileToReplace.uploadedFileId;
      this.fileNameFICA = `BankProof/${uploadedFileBankProofId}`;
      this.uploadFICAURL = `${this.appConfig.apiEndpoint}/CustomerAdmin/${this.helperService.checkCustomerIdState()}/BankAccount/${this.bankAccountId}/UploadedFile/${uploadedFileBankProofId}/Replace/${this.selectedDocumentTypeId}`;
    }
  }

  onReplaceUploadSuccess() {
    this.ficaDocUploadControl(null, null);
    this.closeReplacePopup();
  }
}
